import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { IdDocImageSide } from '@/idv2/features/collect-document/types';
import IdDocAnimation from '../../../components/id-doc-animation';
import Loading from '../../../components/loading';
import RetryLimitExceeded from '../../../components/retry-limit-exceeded';
import Success from '../../../components/success';
import NextSide from '../../components/next-side';
type ProcessingViewProps = {
  mode: 'loading' | 'success';
  step: 'upload' | 'analyze';
  nextSide: IdDocImageSide | undefined;
  showSlowConnectionMessage: boolean;
  retryLimitExceeded: boolean;
  isMissingRequirements: boolean;
  docType: string | undefined;
  currSide: IdDocImageSide | undefined;
  onRetryLimitExceeded: () => void;
  onSuccessComplete: () => void;
  onNextSideComplete: () => void;
};
const ProcessingView = t0 => {
  const $ = _c(21);
  const {
    mode,
    step,
    nextSide,
    showSlowConnectionMessage,
    retryLimitExceeded,
    isMissingRequirements,
    docType,
    currSide,
    onRetryLimitExceeded,
    onSuccessComplete,
    onNextSideComplete
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.id-doc.pages.processing"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  if (isMissingRequirements) {
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <div className="text-label-1 text-error text-center">{t2}</div>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (retryLimitExceeded) {
    let t2;
    if ($[5] !== onRetryLimitExceeded) {
      t2 = <RetryLimitExceeded onRetryLimitExceeded={onRetryLimitExceeded} />;
      $[5] = onRetryLimitExceeded;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  if (!docType || !currSide) {
    return null;
  }
  let t2;
  if ($[7] !== showSlowConnectionMessage || $[8] !== step) {
    t2 = <Loading step={step} showSlowConnectionMessage={showSlowConnectionMessage} />;
    $[7] = showSlowConnectionMessage;
    $[8] = step;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const t3 = mode === "success" && !nextSide ? onSuccessComplete : undefined;
  let t4;
  if ($[10] !== t3) {
    t4 = <Success onComplete={t3} />;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== nextSide || $[13] !== onNextSideComplete) {
    t5 = nextSide && <NextSide nextSideImageType={nextSide} onComplete={onNextSideComplete} />;
    $[12] = nextSide;
    $[13] = onNextSideComplete;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = !!nextSide;
  let t7;
  if ($[15] !== mode || $[16] !== t2 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div className="flex flex-col items-center justify-center h-full min-h-[280px]"><IdDocAnimation loadingComponent={t2} successComponent={t4} nextSideComponent={t5} mode={mode} hasNextSide={t6} /></div>;
    $[15] = mode;
    $[16] = t2;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default ProcessingView;
function _temp($) {
  return $["missing-requirement-error"];
}